import { Link, useLocation } from "react-router-dom";
import { useContext, useRef } from "react";
import { AnswersContext } from "../../store/AnswersContext/AnswersContext";

const breadcrumbMap = {
  "": "Surveys / Profiling",
  tools: "Tools",
  1: "Tool 1",
  2: "Tool 2",
  3: "Tool 3",
  4: "Tool 4",
  5: "Tool 5",
  6: "Tool 6",
};

export default function Header() {
  const location = useLocation();
  const isProfiling = location.pathname === "/";
  const { answerData, parseXlsxFile } = useContext(AnswersContext);
  const fileInputRef = useRef(null);

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const breadcrumbs = pathSegments.map((segment, index) => {
    const path = "/" + pathSegments.slice(0, index + 1).join("/");
    const label = breadcrumbMap[segment] || segment;
    const isLast = index === pathSegments.length - 1;

    return (
      <span key={path}>
        {!isLast ? (
          <Link to={path} className="text-blue-600 hover:underline">
            {label}
          </Link>
        ) : (
          <span className="text-gray-500">{label}</span>
        )}
        {index < pathSegments.length - 1 && <span className="mx-2">/</span>}
      </span>
    );
  });

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.name.endsWith(".xlsx")) {
      parseXlsxFile(file);
    } else {
      alert("Please upload a valid .xlsx file");
    }
  };

  const handleReset = () => {
    localStorage.removeItem("answerData");
    window.location.reload();
  };

  return (
    <header className="sticky top-0 bg-gray-100 w-full flex justify-between px-8 py-8 items-center z-50">
      <span className="w-1/3 text-sm text-gray-700">
        {breadcrumbs.length > 0 ? breadcrumbs : "Profiling"}
      </span>

      <span className="w-1/3 flex justify-center">
        <div className="inline-flex items-center bg-gray-200 p-1 rounded-full">
          <Link to="/">
            <button
              className={`px-4 py-1.5 rounded-full text-sm font-medium transition ${
                isProfiling ? "bg-white text-blue-600" : "text-gray-600"
              }`}
            >
              Profiling
            </button>
          </Link>
          {answerData?.length > 0 ? (
            <Link to="/tools">
              <button
                className={`px-4 py-1.5 rounded-full text-sm font-medium transition ${
                  !isProfiling ? "bg-white text-blue-600" : "text-gray-600"
                }`}
              >
                Tools
              </button>
            </Link>
          ) : (
            <button
              disabled
              className="px-4 py-1.5 rounded-full text-sm font-medium text-gray-400 bg-transparent cursor-default"
            >
              Tools
            </button>
          )}
        </div>
      </span>

      <span className="w-1/3 flex justify-end gap-2">
        <label
          htmlFor="header-file-upload"
          className="cursor-pointer px-4 py-1.5 rounded-full text-sm font-medium bg-white text-green-600 border border-green-300 hover:bg-green-50 transition"
        >
          Upload XLSX
        </label>
        <input
          id="header-file-upload"
          type="file"
          accept=".xlsx"
          ref={fileInputRef}
          onChange={handleFileUpload}
          className="hidden"
        />
        <button
          className="px-4 py-1.5 rounded-full text-sm font-medium bg-white text-red-600 border border-red-300 hover:bg-red-50 transition"
          onClick={handleReset}
        >
          Reset
        </button>
      </span>
    </header>
  );
}
